module.exports = vendor.ReactDOM;


//////////////////
// WEBPACK FOOTER
// external "vendor.ReactDOM"
// module id = 401
// module chunks = 11